import { getGstAtomClient } from "api/services/gstr/config";
import Loader from "components/Loader";
import { createContext, useContext } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ResType } from "types";


export const GstClientContext = createContext<any>(null);

function GstClientProvider({ children }) {
  const { gstrid } = useParams()
  const { data, isLoading }: ResType = useQuery(["get-gst-Client-details", gstrid], getGstAtomClient, {
    enabled: !!gstrid
  })

  if (isLoading) return <Loader minHeight={"60vh"} />;
  return (
    <GstClientContext.Provider value={{ data: data?.data }}>
      {children}
    </GstClientContext.Provider>
  )
}

export const useGstClient = () => useContext(GstClientContext)
export default GstClientProvider